import React, { Component } from "react";
import {
  Row,
  Table,
  Button,
  Alert,
  ModalHeader,
  Modal,
  ModalBody,
  Input,
} from "reactstrap";
import Toggle from "react-toggle";
import axios from "../../axios";
import * as url from "../../utils/url";
import findIndex from "lodash/findIndex";
import Checkbox from "rc-checkbox";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as actionCreators from "../../modules/actions/index";
// import ReactPlayer from 'react-player'
import ReactPlayer from "react-player/lazy";
import moment from "moment";
import "./AddToGroup.css";
import { isEmpty } from "lodash";

class AddToGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      groupList: [],
      isChecked: [],
      modified: [],
      itemsCount: 0,
      modDoc: null,
      displayItems: [],
      type: 1,
      selected: null,
      searchedTerm: "",
      isSuccess: false,
    };
  }

  componentDidMount() {
    let orgId = this.props.user.organizationId._id;

    let payload = {
      orgId,
      itemId: this.props.itemId,
      modelName: this.props.modelName,
    };
    axios.post(url.getItemsGroup, payload).then(({ data }) => {
      this.setState({
        groupList: data.data.groups,
        itemsCount: data.data.count,
        linkedGrp: data.data.linkedItems,
        displayItems: data.data.groups,
        isNoGroups: data.data.groups.length == 0 ? true : false,
      });
    });
  }

  attachTaskItems = () => {
    let { isChecked, selected, linkedGrp, groupList } = this.state;

    if (isChecked.length > 0) {
      let payload = {
        itemId: this.props.itemId,
        modelName: this.props.modelName,
        itemType: this.props.itemType,
        // groupIds:isChecked,
        group: selected,
      };
      let that = this;

      axios.post(url.attachItemGroup, payload).then(({ data }) => {
        let result = groupList.filter(e => e._id != selected._id);
        let doc = { ...data.data, ...selected,itemMainId:data.data._id };
    
        that.setState({
          isSuccess: true,
          linkedGrp: [doc, ...linkedGrp],
          groupList: result,
          selected: null,
          modDoc: doc,
          displayItems: result,
          // selected: {...selected, ...data.data}
        });
        if (that.props.module_name == "SingleTask") {
          let res = [doc, ...linkedGrp];
          that.props.editGroups(res);
        }
      });
    } else {
      let res = "actions";
      this.setState({ errorMsg: `No ${res} attached` });
    }
  };

  editLinkedItem = (event, grp) => {
    // radio button
    // let group = item.target.value
    // console.log('group----', group)
    // let {isChecked, modified}=this.state
    // let res;

    // if(isChecked.indexOf(group._id)>-1){
    // 	isChecked.filter(e=>e!=group)
    // 	this.setState({isChecked})
    // }else{
    // 	isChecked= [...isChecked, group]
    // 	this.setState({isChecked})
    // }
    this.setState({
      isChecked: grp._id,
      selected: grp,
    });
  };

  switchList = () => {
    let { type, linkedGrp, groupList } = this.state;
    if (type == 1) {
      this.setState({
        displayItems: linkedGrp,
        type: 0,
        selected: null,
        modDoc: null,
        isSuccess: false,
      });
    } else {
      this.setState({
        displayItems: groupList,
        type: 1,
        selected: null,
        modDoc: null,
        isSuccess: false,
      });
    }
  };

  handleSearchQueryChanged = ({ target }) => {
    const { name, value } = target;
    let { groupList, linkedGrp, displayItems, type } = this.state;
    let list = [];
    let fList = type == 1 ? groupList : linkedGrp;
    if (value.length === 0) {
      list = fList;
    } else {
      list = fList.filter(e =>
        e.name.toLowerCase().includes(value.toLowerCase())
      );
    }
    this.setState({
      displayItems: list,
      searchedTerm: value,
    });
  };

  removeGroup = modelDoc => {
    let { linkedGrp, selected } = this.state;
    console.log(modelDoc)
    let payload = {
      modelId: modelDoc.modelId,
      modelName: modelDoc.onModel,
      itemType: modelDoc.itemType,
      _id: modelDoc.itemMainId ? modelDoc.itemMainId: modelDoc._id,
      // groupIds:isChecked,
      groupId: modelDoc.groupId && modelDoc.groupId._id ? modelDoc.groupId._id : modelDoc._id,
    };
    let that = this;
    axios.post(url.removeGrpItem, payload).then(({ data }) => {
      let result = linkedGrp.filter(e => e._id != modelDoc._id);
      let doc = {
        ...selected,
        
      };
      if(modelDoc.groupId._id){
      doc = {...doc,...modelDoc.groupId}  
      }else{
        doc = {...doc,...modelDoc} 
      }
      that.setState({
        isSuccess: true,
        selected: null,
        linkedGrp: result,
        modDoc: doc,
        groupList: [doc, ...this.state.groupList],
        displayItems: result,
        // groupList:
        // isSuccessMsg: 0,
        // selected: {...selected, ...data.data}
      });
      if (that.props.module_name == "SingleTask") {
        that.props.editGroups(result);
      }
    });
  };

  viewGroup = grp => {
    grp = typeof grp == "object" ? grp._id : grp;
    this.props.history.push(
      `/home/groups/${this.props.user.organizationId._id}/view/${grp}`
    );
  };

  renderView = () => {
    let { type, displayItems, selected, isNoGroups } = this.state;
    if (displayItems && displayItems.length > 0) {
      if (type == 1) {
        return displayItems.map((itm, idx) => {
          return (
            <div
              className="radio ml-1 mt-0 radio-label-group-add-align"
              key={itm._id + idx}
            >
              <input
                id={itm._id}
                name="meRadio"
                onChange={e => this.editLinkedItem(e, itm)}
                style={{
                  marginBottom:
                    this.props.module_name === "SingleTask"
                      ? "20px"
                      : "inherit",
                }}
                type="radio"
                value={itm._id}
                checked={selected && selected._id == itm._id ? true : ""}
              />
              <label
                htmlFor={itm._id}
                className="radio-label privacy-radio-label privacy-radio-value"
              >
                <span className="radio-label link_ent_obj_title">
                  {itm.name}
                </span>
                {/* <span className="link_ent_obj_date">created on {moment(itm.createdOn).format("MMM D, YYYY")}</span> */}
              </label>
            </div>
          );
        });
      } else {
        return (
          <div className="singleTaskToolkitTableContainerBox">
            <Table responsive hover className="taskToolkitTable">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Linked on</th>
                  {/* <th>Created By</th> */}
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {displayItems.map((itm, idx) => {
                  return (
                    <tr className="linkedToolTable" key={itm._id}>
                      <td>
                        {itm.groupId && itm.groupId.name ? itm.groupId.name : itm.name}
                        <div
                          className="linkedToolView"
                          onClick={() => this.viewGroup(itm.groupId)}
                        >
                          (view)
                        </div>
                      </td>

                      <td>{moment(itm.createdAt).format("MMM Do, YYYY")}</td>
                      <td>
                        <span
                          className="flaticon-trash"
                          onClick={() => this.removeGroup(itm)}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        );
      }
    } else {
      if (isNoGroups) {
        return <span> No groups were found </span>;
      } else {
        return <span> No groups to link. </span>;
      }
    }
  };

  onDismiss = () => {
    this.setState(prevState => ({
      isSuccess: !prevState.isSuccess,
      selected: null,
    }));
  };

  renderItemName = () => {
    let { item } = this.props;
    let res = "";
    if (item) {
      if (item.name) {
        res = item.name;
      } else if (item.title) {
        res = item.title;
      }
    }
    return (
      <span className="grp_items_modal_title">
        Add{" "}
        <span className="grp_items_modal_itm_title">
          {res != "" ? `"${res}"` : ""}
        </span>{" "}
        to a Group
      </span>
    );
  };

  render() {
    const { module_name } = this.props;
    let {
      groupList,
      modDoc,
      isChecked,
      selected,
      isSuccess,
      type,
      searchedTerm,
    } = this.state;
    return (
      <div>
        {module_name == "SingleTask" ? (
          <div className="create-stories">
            <div className="singleTaskModalBody">
              Find group(s) are a member of below.{" "}
              <span
                className="seeLinkedGrpTxt"
                onClick={() => this.switchList()}
              >
                {" "}
                {type == 1
                  ? "Click here to view linked groups"
                  : "Click here to view groups"}
              </span>
              .{/* Currently {itemsCount} linked. */}
            </div>

            <Input
              className="singleTaskItemSearch"
              placeholder="Search by name"
              onChange={this.handleSearchQueryChanged}
              value={searchedTerm}
            />

            {isSuccess ? (
              <Alert color="success" isOpen={isSuccess} toggle={this.onDismiss}>
                <strong>{modDoc.name}</strong>{" "}
                {type == 1
                  ? "group was linked."
                  : "group was unlinked from this item."}
              </Alert>
            ) : null}

            <div className="divTableBody">{this.renderView()}</div>

            <div
              className="singleTaskModalBtn"
              style={{ padding: "10px 0px 0px 0px" }}
            >
              {type == 1 ? (
                <Button
                  className={`profile-modal-save-btn float-left weeklyWinBtn ${
                    selected && selected._id ? "" : "noClickBtn"
                  }`}
                  onClick={
                    selected && selected._id
                      ? () => this.attachTaskItems()
                      : null
                  }
                >
                  <span className="profile-modal-save-btn-txt">
                    Link to Group
                    <span className="ml10 flaticon-tick"></span>
                  </span>
                </Button>
              ) : null}

              <Button
                className="profile-modal-cancel-btn float-right weeklyWinBtn"
                onClick={this.props.closeGroupModal}
              >
                <span className="profile-modal-cancel-btn-txt">Close</span>
              </Button>
            </div>
          </div>
        ) : (
          <Modal
            isOpen={this.props.isOpen}
            className="ent-obj-link-modal linkTaskItemsModal groupItemsModal"
          >
            <ModalHeader
              className="dashboardHeader"
              charCode="X"
              toggle={this.props.closeGroupModal}
            >
              <div className="dashboardModalTitle">{this.renderItemName()}</div>
            </ModalHeader>
            <ModalBody className="create-stories">
              <div className="singleTaskModalBody">
                Find group(s) are a member of below.{" "}
                <span
                  className="seeLinkedGrpTxt"
                  onClick={() => this.switchList()}
                >
                  {" "}
                  {type == 1
                    ? "Click here to view linked groups"
                    : "Click here to view groups"}
                </span>
                .{/* Currently {itemsCount} linked. */}
              </div>

              <Input
                className="singleTaskItemSearch"
                placeholder="Search by name"
                onChange={this.handleSearchQueryChanged}
                value={searchedTerm}
              />

              {isSuccess ? (
                <Alert
                  color="success"
                  isOpen={isSuccess}
                  toggle={this.onDismiss}
                >
                  <strong>{modDoc.name}</strong>{" "}
                  {type == 1
                    ? "group was linked."
                    : "group was unlinked from this item."}
                </Alert>
              ) : null}

              <div className="divTableBody">{this.renderView()}</div>

              <div
                className="singleTaskModalBtn"
                style={{ padding: "10px 0px 0px 0px" }}
              >
                {type == 1 ? (
                  <Button
                    className={`profile-modal-save-btn float-left weeklyWinBtn ${
                      selected && selected._id ? "" : "noClickBtn"
                    }`}
                    onClick={
                      selected && selected._id
                        ? () => this.attachTaskItems()
                        : null
                    }
                  >
                    <span className="profile-modal-save-btn-txt">
                      Link to Group
                      <span className="ml10 flaticon-tick"></span>
                    </span>
                  </Button>
                ) : null}

                <Button
                  className="profile-modal-cancel-btn float-right weeklyWinBtn"
                  onClick={this.props.closeGroupModal}
                >
                  <span className="profile-modal-cancel-btn-txt">Close</span>
                </Button>
              </div>
            </ModalBody>
          </Modal>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.profile,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    storyMetricsChange: data =>
      dispatch(actionCreators.storyMetricsChange(data)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddToGroup)
);
